// let maxPageContentHeight = Math.floor(1300/36)
export const MAX_PAGE_CONTENT_HEIGHT = 37;
export const MAX_PAGE_CONTENT_WIDTH = 6;

/**
 * 
 * @deprecated This does not work... sad...
 */
function convertLayoutFromDashboardToReportMode(viewLayout) {
  if (!viewLayout) return;

  // to check if there is an widget height is larger than maxPageContentHeight
  // let isWidgetHeightOverMaxPageContentHeightExisting = false
  let lastPageBreakY = 0;
  let pageBreakCandidates = new Set();

  // Add widget top and bottom to page break candidates
  for (let widgetLayout of viewLayout.layout) {
    pageBreakCandidates.add(widgetLayout.y);
    pageBreakCandidates.add(widgetLayout.y + widgetLayout.h);
  }

  // Remove page break candidates that are in the middle of a widget
  for (let widgetLayout of viewLayout.layout) {
    for (let pageBreakCandidate of pageBreakCandidates) {
      if (widgetLayout.y < pageBreakCandidate && pageBreakCandidate < widgetLayout.y + widgetLayout.h)
        pageBreakCandidates.delete(pageBreakCandidate);
    }
  }

  // Find page breaks that can fit the maximum amount of widgets while not exceeding the maximum page content height.
  let sortedPageBreakCandidates = Array.from(pageBreakCandidates);
  sortedPageBreakCandidates.sort((a, b) => a - b);
  let pageBreaks = [];
  let currentPageTop = 0;
  let currentPageContentHeight = 0;

  let cpt = 0;
  for (
    let pageBreakCandidateInd = 0;
    pageBreakCandidateInd < sortedPageBreakCandidates.length;
    pageBreakCandidateInd++
  ) {
    if (cpt++ > 1000) break;
    let pageBreakCandidate = sortedPageBreakCandidates[pageBreakCandidateInd];
    if (pageBreakCandidate - currentPageTop < MAX_PAGE_CONTENT_HEIGHT) {
      // If the content fits inside the page,
      // keep going.
      currentPageContentHeight = pageBreakCandidate - currentPageTop;
    } else {
      // If the content does NOT fit inside the page,
      // add a page break.
      if (currentPageContentHeight == 0) {
        // If it is the first candidate, it means than one widget is bigger than the page.
        // In that case cut anyway.
        pageBreaks.push(pageBreakCandidate);
        currentPageTop = pageBreakCandidate;
        currentPageContentHeight = 0;
        console.log('Inevitable page overflow... Please, check if on widget is not bigger than the page size.');
        // isWidgetHeightOverMaxPageContentHeightExisting = true
      } else {
        // Cut at the previous break, to avoid page overflow.
        let previousPageBreakCandidate = sortedPageBreakCandidates[pageBreakCandidateInd - 1];
        pageBreaks.push(previousPageBreakCandidate);
        currentPageTop = previousPageBreakCandidate;
        pageBreakCandidateInd--;
        currentPageContentHeight = 0;
      }
    }
  }

  if (pageBreaks[pageBreaks.length - 1] != sortedPageBreakCandidates[sortedPageBreakCandidates.length - 1]) {
    pageBreaks.push(sortedPageBreakCandidates[sortedPageBreakCandidates.length - 1]);
  }

  // Prepare each page of the report layout
  let numberOfPage = pageBreaks.length;
  let reportModelLayout = {
    // isWidgetHeightOverMaxPageContentHeightExisting
  };
  for (let pageInd = 0; pageInd < numberOfPage; pageInd++) {
    reportModelLayout[pageInd] = {
      pageGridId: pageInd,
      layout: [],
      disabled: false,
    };
  }

  // Put each widget in its page.
  for (let widgetLayout of viewLayout.layout) {
    // Search for the page containing this widget.
    for (let pageInd = 0; pageInd < numberOfPage; pageInd++) {
      let prevPageBreak = pageBreaks[pageInd - 1] ?? 0;
      let pageBreak = pageBreaks[pageInd];
      if (widgetLayout.y < pageBreak) {
        // Add the widget to its page.
        reportModelLayout[pageInd].layout.push({
          ...widgetLayout,
          w: Math.min(widgetLayout.w, MAX_PAGE_CONTENT_WIDTH),
          // widgetLayout.y < 0 set 0
          y: Math.max(widgetLayout.y, 0) - prevPageBreak,
        });
        break;
      }
    }
  }

  return reportModelLayout;
}

/**
 * 
 * @deprecated This does not work, sad...
 */
function convertLayoutFromReportModeToDashboardMode(reportLayout) {
  const nPage = Object.keys(reportLayout).length;
  // Calculate the height of each page.
  let pageHeights = [];
  for (let pageInd = 0; pageInd < nPage; pageInd++) {
    const pageLayout = reportLayout[pageInd].layout;
    let widgetBottoms = pageLayout.map(widget => widget.y + widget.h);
    let pageHeight = widgetBottoms.reduce((a, b) => Math.max(a, b));
    pageHeights[pageInd] = pageHeight;
  }
  // Move back each widget by shifting them by the cummulative heights of previous pages.
  let prevPagesCumSum = 0;
  let dashboardLayout = { layout: [], disabled: false };
  for (let pageInd = 0; pageInd < nPage; pageInd++) {
    const pageLayout = reportLayout[pageInd].layout;
    for (let widget of pageLayout) {
      dashboardLayout.layout.push({
        ...widget,
        y: widget.y + prevPagesCumSum,
      });
    }
    prevPagesCumSum += pageHeights[pageInd];
  }

  return dashboardLayout;
}


function convertLayoutFromReportModeToDashboardModeTetris(reportLayout, colNum = MAX_PAGE_CONTENT_WIDTH) {
  // colNum == 3 => x = {0, 1, 2}
  const eachColCurrY = new Array(colNum).fill(0);
  let newLayout = [];

  const pageEntries = Object.entries(reportLayout).sort(
    ([pageIdx1], [pageIdx2]) => parseInt(pageIdx1, 10) - parseInt(pageIdx2, 10),
  );
  for (let [pageIdx, reportLayout] of pageEntries) {
    pageIdx = parseInt(pageIdx);
    reportLayout.layout.sort((a, b) => a.y - b.y);

    for (let widget of reportLayout.layout) {
      let { x, w, h } = widget;

      if (w > colNum) {
        console.log(`Error: w is ${w} > max width: ${colNum}`);
        w = colNum;
      }

      let max = 0;
      for (let i = x; i < x + w; i++) {
        if (eachColCurrY[i] > max) {
          max = eachColCurrY[i];
        }
      }

      for (let i = x; i < x + w; i++) {
        eachColCurrY[i] = max + h;
      }

      newLayout.push({
        ...widget,
        y: max,
        w,
      });
    }
  }

  return { layout: newLayout, disabled: false };
}

function checkNewWidgetCollision(reportLayout, pageInd, newWidgetX, newWidgetY, newWidgetWidth, newWidgetHeight) {
  for (let widget of reportLayout[pageInd].layout) {
    let r1x = newWidgetX;
    let r1y = newWidgetY;
    let r1w = newWidgetWidth;
    let r1h = newWidgetHeight;
    let { x: r2x, y: r2y, w: r2w, h: r2h } = widget;
    let collision = r1x + r1w > r2x && r1x < r2x + r2w && r1y + r1h > r2y && r1y < r2y + r2h;
    if ('drop' === widget.i) continue;
    if (collision) {
      return true;
    }
  }
  return false;
}
function checkAddingNewWidgetToReportLayout(
  reportLayout,
  pageInd,
  mouseGridX,
  mouseGridY,
  newWidgetWidth,
  newWidgetHeight,
) {
  let newWidgetX = Math.ceil(mouseGridX - newWidgetWidth / 2);
  if (newWidgetX < 0) newWidgetX = 0;
  if (newWidgetX + newWidgetWidth > MAX_PAGE_CONTENT_WIDTH) newWidgetX = MAX_PAGE_CONTENT_WIDTH - newWidgetWidth;
  let newWidgetY = Math.floor(mouseGridY - newWidgetHeight / 2);
  if (newWidgetY < 0) newWidgetY = 0;
  if (newWidgetY + newWidgetHeight >= MAX_PAGE_CONTENT_HEIGHT) newWidgetY = MAX_PAGE_CONTENT_HEIGHT - newWidgetHeight;

  // TODO need to check y
  let hasCollision = checkNewWidgetCollision(
    reportLayout,
    pageInd,
    newWidgetX,
    newWidgetY,
    newWidgetWidth,
    newWidgetHeight,
  );
  return { newWidgetX, newWidgetY, isDropPossible: !hasCollision };
}

// for check if adding an widget is possible
function Point(x, y) {
  this.x = x;
  this.y = y;
}

function findRectangular(matrix, i, j, w, h) {
  let rowStart = i;
  let colStart = j;
  let startCoordinate = new Point(j, i);
  // let endCoordinate;

  while (j < matrix[0].length && matrix[i][j] == 0) {
    j++;
  }
  if (j - colStart < w) return;

  let colEnd = --j;
  i++;
  j = colStart;
  while (i < matrix.length && matrix[i][j] == 0) {
    while (j <= colEnd) {
      j++;
    }
    j = colStart;
    i++;

    if (i - rowStart >= h) {
      // endCoordinate = new Point(colEnd, --i);
      return new Point(colStart, rowStart);
    }
  }
  return;
}

function createMatrixOccupied(layout, maxH, maxW) {
  const matrix = new Array(maxH);

  for (let i = 0; i < maxH; i++) {
    matrix[i] = new Array(maxW).fill(0);
  }

  for (let j = 0; j < layout.length; j++) {
    let { x, y, w, h } = layout[j];

    x = Math.max(x, 0);

    // defense logic: some widgets have xx.xxx... y
    y = parseInt(y, 10);
    y = Math.max(y, 0);

    const height = Math.min(maxH, y + h);
    const width = Math.min(maxW, x + w);

    for (let row = y; row < height; row++) {
      for (let col = x; col < width; col++) {
        matrix[row][col] = 1;
      }
    }
  }

  return matrix;
}

function hasSpaceForAnWidget(layout, widget) {
  if (!layout) return;
  if (!widget) return;

  // console.time('hasSpaceForAnWidget');
  let coordinate;
  let flag = false;
  const { w, h } = widget;

  // get matrix
  const matrix = createMatrixOccupied(layout, MAX_PAGE_CONTENT_HEIGHT, MAX_PAGE_CONTENT_WIDTH);

  // check if possible to add an widget
  for (let i = 0; i < matrix.length; i++) {
    if (flag) {
      break;
    }

    for (let j = 0; j < matrix[0].length; j++) {
      if (matrix[i][j] == 0) {
        coordinate = findRectangular(matrix, i, j, w, h);
        if (coordinate) {
          flag = true;
          break;
        }
      }
    }
  }
  // console.timeEnd('hasSpaceForAnWidget');

  return { coordinate, isAddingPossible: flag };
}

module.exports = {
  convertLayoutFromDashboardToReportMode,
  convertLayoutFromReportModeToDashboardMode,
  checkAddingNewWidgetToReportLayout,
  hasSpaceForAnWidget,
  convertLayoutFromReportModeToDashboardModeTetris,
};
